import { Divider, type DividerProps } from "@mantine/core";

const SSDivider: React.FC<DividerProps> = (props) => (
  <Divider
    classNames={{
      root: "border-primary-light",
    }}
    {...props}
  />
);

export default SSDivider;
